import TrackingDataGoogleEvent from "./TrackingDataGoogleEvent";
import TrackingDataGooglePageView from "./TrackingDataGooglePageView";
import TrackingModule from "./TrackingModule";

/**
 * @class
 * @memberOf P3.tracking
 */
export default class TrackingModuleGoogle extends TrackingModule {
    /**
     * @param {string} code
     */
    constructor(code) {
        super();

        this.window = window.top || window;
        if (this.isScriptFound()) {
            ga("create", code, "auto")
        }
    }

    /**
     * @param {TrackingDataGoogleEvent|TrackingDataGooglePage} data
     */
    track(data) {
        if (this.isScriptFound()) {
            if (data instanceof TrackingDataGoogleEvent) {
                ga("send", "event", data.category, data.action, data.label, data.value);
            } else if (data instanceof TrackingDataGooglePageView) {
                ga("send", "pageview", "/" + data.page);
            }
        }
        super.track(data);
    }

    isScriptFound() {
        if (!ga) {
            console.warn("Google Analytics script is not found.");
            return false;
        }
        return true;
    }
}